// extracted by mini-css-extract-plugin
export var container = "styles-module--container--lfCGO";
export var img = "styles-module--img--K2M1u";
export var imgCol = "styles-module--imgCol--tieLK";
export var partnerLogo = "styles-module--partnerLogo--XeicO";
export var subHeadline = "styles-module--subHeadline--W64up";
export var text = "styles-module--text--GpY9h";
export var textCol = "styles-module--textCol--hK7rR";
export var textWrapper = "styles-module--textWrapper--dNqC-";